<template>

<app-view-sheet-field align="center" :is-condensed="isCondensed" :is-sticky="isSticky" :field="field" :filter="filter">

    <template v-if="value !== '-'">{{ value | round(2) }}</template>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isCondensed', 'isSticky'],

	computed: {

		value: function() {

			return this.item.group.rating_avg

		}

	}

}

</script>

<style scoped>

</style>